import { motion } from 'framer-motion';

const ScrollReveal = ({ children, delay = 0 }) => {
    return (
        <motion.section
            initial={{ opacity: 0, y: 40 }} 
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{
                once: true,
                amount: 0.05,
                margin: "0px 0px 0px 0px"
            }}
            transition={{
                duration: 0.8,
                ease: [0.21, 0.47, 0.32, 0.98], 
                delay: delay
            }}
        >
            {children}
        </motion.section>
    );
};

export default ScrollReveal;